package pl.decks.chartjs.silk.color

import com.varabyte.kobweb.compose.ui.graphics.Color
import pl.decks.chartjs.color.ChartColor

fun Color.toChartColor(): ChartColor {
    val rgb = this.toRgb()
    return ChartColor.rgba(
        r = rgb.red,
        g = rgb.green,
        b = rgb.blue,
        a = rgb.alphaf,
    )
}
